const state = {
    nav_bar_visible: true,
    unauthorized_panel_visible: false
}
const getters = {
        nav_bar_visible:(state)=> {
        return state.nav_bar_visible;
      },
      unauthorized_panel_visible:(state)=> {
        return state.unauthorized_panel_visible;
      }
}
const mutations = {
      set_nav_bar_visible (state, value) {
        state.nav_bar_visible = value;
      },
      set_unauthorized_panel_visible (state, value) {
        state.unauthorized_panel_visible = value;
      }
}
// actions
const actions = {
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
